import React from 'react';
import { injectIntl } from 'react-intl';
import carouselPropTypes from '../prop-types/carouselPropTypes';
import SliderArrow from './SliderArrow';
import ArrowIcon from './ArrowIcon';

var CarouselArrow = function CarouselArrow(props) {
  var onClick = props.onClick,
      slide = props.slide,
      arrowType = props.arrowType,
      arrowCustomColor = props.arrowCustomColor,
      className = props.className,
      arrowSize = props.arrowSize,
      labelId = props.labelId,
      children = props.children,
      rtl = props.rtl,
      intl = props.intl,
      vertical = props.vertical;
  return /*#__PURE__*/React.createElement(SliderArrow, Object.assign({
    className: className,
    onClick: onClick,
    slide: slide,
    vertical: vertical,
    arrowType: arrowType
  }, props), slide === 'next' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowIcon, {
    arrowSize: arrowSize,
    vertical: vertical,
    arrowType: arrowType,
    arrowCustomColor: arrowCustomColor,
    slide: "next",
    label: intl.formatMessage({
      id: labelId
    }),
    rtl: rtl
  }), children), slide === 'prev' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ArrowIcon, {
    arrowSize: arrowSize,
    vertical: vertical,
    arrowType: arrowType,
    arrowCustomColor: arrowCustomColor,
    slide: "prev",
    label: intl.formatMessage({
      id: labelId
    })
  }), children));
};

CarouselArrow.defaultProps = {
  arrowSize: 'default',
  arrowType: 'default',
  arrowCustomColor: null,
  rtl: false,
  children: null,
  onClick: null,
  className: null,
  vertical: false
};
export default injectIntl(CarouselArrow);